import React from "react";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import {
  Row,
  Col,
  Button,
  Dropdown,
  Modal,
  Form,
  Breadcrumb,
} from "react-bootstrap";
import { FiHome, FiUpload, FiPlus, FiChevronUp } from "react-icons/fi";
import ProjectBoard from "../../components/Applications/kanban/ProjectBoard";
const KanbanPage = () => {
  return (
    <div style={{ padding: "20px", background: "#f8f9fa", height: "100vh" }}>
      <Row className="align-items-center justify-content-between mb-3">
        {/* <Col md={6}>
          <h3 className="mb-1 fw-bold">Escalation Rules</h3>

          <div className="d-flex align-items-center text-muted">
            <FiHome size={16} />
            <span className="mx-2">Tickets</span>
            <span>Escalation Rules</span>
          </div>
        </Col> */}
        <Col md={6} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
              Kanban View
            </h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <RiHome6Line
                  className="m text-dark"
                  style={{
                    fontSize: "1.2rem", // increased icon size
                    verticalAlign: "middle",
    
                  }}
                />
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Applications
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">Kanban View</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>

        <Col
          style={{ backgroundColor: "whitesmoke" }}
          md={6}
          className="text-md-end mt-2 mt-md-0  "
        >
          <Dropdown className=" me-2">
            <Dropdown.Toggle className="border " variant="light">
              <FiUpload className="me-1" />
              Export
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>Export as PDF</Dropdown.Item>
              <Dropdown.Item>Export as Excel</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* <Button
            style={{ background: "#ed6402", border: "none" }}
            className="me-2"
            onClick={() => setAddRule(true)}
          >
            <FiPlus className="me-2" />
            Add New Rule
          </Button> */}

          {/* <Button variant="light">
            <FiChevronUp />
          </Button> */}
        </Col>
      </Row>
      <ProjectBoard />
    </div>
  );
};

export default KanbanPage;
